<template>
    <div class="schedule-item">
        <div class="header">
            <div class="theme dev" v-if="event.theme === 'Dev'">DEV</div>
            <div class="theme design" v-else-if="event.theme === 'Design'">DESIGN</div>
            <div class="theme tech" v-else-if="event.theme === 'Tech'">TECH</div>
            <div class="theme marketing" v-else-if="event.theme === 'Marketing'">MARKETING</div>
            <div>
                <img src="../../assets/icons/clock.svg" alt="Sat">
            </div>
            <div class="time">{{ event.starts | filterTimeFromDate }}-{{ event.ends | filterTimeFromDate }}</div>
            <a class="event-footage" v-if="event.footageLink && event.footageLink.length" v-bind:href="event.footageLink" target="_blank" rel="noreferrer">
                <svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="youtube-icon" transform="translate(-174.000000, -562.000000)">
                            <path d="M185.46225,576.175892 L185.461406,568.213009 L192.756469,572.208178 L185.46225,576.175892 Z M201.48,566.833166 C201.48,566.833166 201.215906,564.880307 200.40675,564.02034 C199.379906,562.891136 198.229031,562.885822 197.701687,562.820284 C193.923375,562.533333 188.255906,562.533333 188.255906,562.533333 L188.244094,562.533333 C188.244094,562.533333 182.576625,562.533333 178.798313,562.820284 C178.270125,562.885822 177.120094,562.891136 176.092406,564.02034 C175.28325,564.880307 175.02,566.833166 175.02,566.833166 C175.02,566.833166 174.75,569.127 174.75,571.419949 L174.75,573.570308 C174.75,575.864143 175.02,578.157092 175.02,578.157092 C175.02,578.157092 175.28325,580.109951 176.092406,580.969918 C177.120094,582.099122 178.46925,582.063696 179.07,582.181487 C181.23,582.399357 188.25,582.466667 188.25,582.466667 C188.25,582.466667 193.923375,582.45781 197.701687,582.170859 C198.229031,582.104436 199.379906,582.099122 200.40675,580.969918 C201.215906,580.109951 201.48,578.157092 201.48,578.157092 C201.48,578.157092 201.75,575.864143 201.75,573.570308 L201.75,571.419949 C201.75,569.127 201.48,566.833166 201.48,566.833166 L201.48,566.833166 Z" id="Fill-25"></path>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
        <div class="content">
            <span class="title">{{ event.name }}</span>
            <template v-if="event.eventUsers && event.eventUsers.length && (doAllEventUsersHaveTheSameCompany() || event.eventUsers.length === 1) && event.eventUsers[0].user.company">
                <img class="schedule-logo" v-bind:class="getCompanyNameNormalized(event.eventUsers[0].user.company.name)" v-bind:src="getSponsorLogo()" v-bind:alt="`${event.eventUsers[0].user.company.name} logo`">
            </template>
            <template v-else>
                <img class="schedule-logo"/>
            </template>
            <template v-if="event.description && event.description.length">
                <i class="arrow"></i>
            </template>
        </div>
        <div class="lecturers">
            <span v-if="event.eventUsers && event.eventUsers.length === 1">
                {{ event.eventUsers[0].user.firstName }} {{ event.eventUsers[0].user.lastName }}<span v-if="event.eventUsers && event.eventUsers.length && event.eventUsers[0].user && event.eventUsers[0].user.lecturerTitle">, {{ event.eventUsers[0].user.lecturerTitle }}</span>
            </span>
            <template v-else>
                <span v-for="(eventUser, index) in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
                    {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}<span v-if="eventUser.user && eventUser.user.lecturerTitle"> (<span v-if="eventUser.userEventRole === 'Moderator'">Moderator, </span>{{ eventUser.user.lecturerTitle }})</span><span v-if="index !== event.eventUsers.length - 1">, </span>
                </span>
            </template>
        </div>
        <div class="description">
            <p v-if="event.description">
                {{ event.description }}
            </p>
            <div v-if="event.eventUsers && event.eventUsers.length">
                <div class="user-container" v-for="eventUser in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
                    <div class="user-details" v-if="eventUser.user.hasImage">
                        <div>
                            <img v-bind:src="getSpeakerImage(getSpeakerNameNormalized(eventUser.user.firstName + eventUser.user.lastName))" v-bind:alt="`${eventUser.user.firstName} ${eventUser.user.lastName}`"/>
                        </div>
                        <div>
                            <div>
                                {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
                            </div>
                            <span v-if="eventUser.user.lecturerTitle && eventUser.user.lecturerTitle.length"> ({{ eventUser.user.lecturerTitle }})</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Event',
        props: {
            event: {}
        },
        methods: {
            getSponsorLogo: function() {
                return require(`../../assets/companies/logos/${this.event.eventUsers[0].user.company.name.replace(/\s/g, '').toLowerCase()}.png`);
            },
            getCompanyNameNormalized: function(companyName) {
                return companyName.replace(/\s/g, '').toLowerCase();
            },
            getSpeakerImage: function(speakerNameNormalized) {
                return require(`../../assets/speakers/images/${speakerNameNormalized}.jpg`);
            },
            getSpeakerNameNormalized: function(speakerName) {
                return speakerName.replace(/\s/g, '').toLowerCase();
            },
            doAllEventUsersHaveTheSameCompany: function() {
                let companyIds = this.event.eventUsers.filter(eu => eu.user !== null && eu.user.company !== null).map(eu => eu.user.company.id);
                let uniqueCompanyIds = [ ...new Set(companyIds) ];
                if(uniqueCompanyIds.length > 1)
                    return false;
                return true;
            },
            getSortedEventUsers: function(event) {
                return event.eventUsers.filter(eu => eu.user !== null).sort(function(firstEventUser, secondEventUser) {
                    if(firstEventUser.userEventRole < secondEventUser.userEventRole)
                        return -1;
                    else if(firstEventUser.userEventRole > secondEventUser.userEventRole)
                        return 1;
                    if(firstEventUser.user.lastName < secondEventUser.user.lastName)
                        return -1;
                    return 1;
                });
            }
        },
        mounted() {
            let dropdownArrow = this.$el.querySelector('.arrow');
            if(dropdownArrow)
            {
                let description = this.$el.querySelector('.description');
                dropdownArrow.addEventListener('click', function(){
                    dropdownArrow.classList.toggle('active');
                    description.classList.toggle('active');
                });
            }
        }
    }
</script>

<style scoped>
.header {
    display: flex;
    align-items: center;
}

.header img {
    padding-top: 4px;
    margin-right: 7px;
}

.theme {
    color: white;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 6px;
    margin-right: 10px;
}

.theme.dev {
    background-color: #30cec1;
}

.theme.design {
    background-color: #FF575F;
}

.theme.tech {
    background-color: #2C373F;
}

.theme.marketing {
    background-color: #D6BD42;
}

.time {
    font-size: 14px;
    opacity: 0.5;
    margin-right: 10px;
}

.content {
    display: flex;
    max-height: 60px;
    align-items: center;
}

.title {
    font-weight: 800;
    font-size: 22px;
}

img.schedule-logo {
    max-height: 90px;
    max-width: 140px;
    margin-left: auto;
}

.lecturers {
    width: 85%;
}

.lecturers span {
    font-size: 16px;
    font-weight: 300;
}

i {
    border: solid black;
    border-width: 0 4px 4px 0;
    display: inline-block;
    padding: 6px;
    transform: rotate(45deg);
}

i:hover {
    cursor: pointer;
}

i.active {
    border-color: #30cec1;
    transform: rotate(225deg);
}

.description {
    transition: max-height 0.5s;
    margin-top: 20px;
    max-height: 0;
    overflow: hidden;
}

.description.active {
    max-height: 1200px;
}

.description p {
    width: 65%;
    line-height: 30px;
    opacity: 0.65;
    word-wrap: break-word;
}

.user-container {
    display: flex;
    flex-wrap: wrap;
}

.user-details {
    display: flex;
    align-items: center;
    margin-right: 30px;
    margin-top: 10px;
}

.user-details img {
    height: 70px;
    width: 70px;
    border-radius: 15px;
    margin-right: 10px;
}

.schedule-item .event-footage svg {
    margin-top: 2px;
}

.schedule-item .event-footage svg #youtube-icon {
    fill: #30cec1;
}

.schedule-item .event-footage svg #youtube-icon:hover {
    fill: red;
}

.schedule-item .schedule-logo.rimacautomobili,
.schedule-item .schedule-logo.sekuracollective,
.schedule-item .schedule-logo.electrocoin {
    transform: scale(1.3);
}

.schedule-item .schedule-logo.sekuracollective,
.schedule-item .schedule-logo.electrocoin {
    margin-right: 20px;
}

.schedule-item .schedule-logo.imago {
    transform: scale(1.2);
}

.schedule-item .schedule-logo.sessionize\.com,
.schedule-item .schedule-logo.beta\&co\. {
    transform: scale(0.9);
}

.schedule-item .schedule-logo.netokracija {
    transform: scale(0.8);
}

.schedule-item .schedule-logo.infinum,
.schedule-item .schedule-logo.toptal,
.schedule-item .schedule-logo.crnojaje,
.schedule-item .schedule-logo.hattrick,
.schedule-item .schedule-logo.lilcodelab,
.schedule-item .schedule-logo.extensionengine {
    transform: scale(0.7);
}

.schedule-item .schedule-logo.bornfight {
    transform: scale(0.6);
}

.schedule-item .schedule-logo.atos,
.schedule-item .schedule-logo.five,
.schedule-item .schedule-logo.ericssonnikolatesla,
.schedule-item .schedule-logo.flyingpenguin {
    transform: scale(0.5);
}

@media screen and (max-width: 980px) {
    .content {
        max-height: 80px;
    }
}

@media screen and (max-width: 768px) {
    .title {
        display: inline-block;
        width: 100%;
    }
}

@media screen and (max-width: 660px) {
    img.schedule-logo {
        max-height: 70px;
        max-width: 110px;
    }

    .description p {
        width: 80%;
    }

    .title {
        display: inline-block;
        width: 80%;
        font-size: 20px;
    }

    .lecturers {
        margin-top: 10px;
    }

    .lecturers span {
        font-size: 14px;
    }
}

@media screen and (max-width: 500px) {
    .content {
        max-height: 100px;
    }

    img.schedule-logo {
        max-height: 60px;
    }
}

@media screen and (max-width: 450px) {
    img.schedule-logo {
        display: none;
    }
    
    .title {
        width: 95%;
    }
    
    i {
        margin-left: auto;
    }

    .description p {
        width: 100%;
    }
}

@media screen and (max-width: 380px) {
    .content {
        max-height: 120px;
    }
}
</style>